import { Core } from "../core/core";
import { getState } from "./get-state";
import { resetState } from "./reset-state";
import { setState } from "./set-state";

/**
 * Initiate state stuff on Stored Platform
 *
 * @export
 */
export function installState() {
    Core.state.enabled = true;
    Core.state.getState = getState;
    Core.state.setState = setState;
    Core.state.resetState = resetState;
}
